<template>
  <v-text-field
    :id="id"
    :append-icon="appendInnerIcon"
    :autocomplete="autocomplete"
    :autofocus="autofocus"
    :class="[customClasses]"
    :clear-icon="clearIcon"
    :clearable="clearable"
    :color="color"
    :counter="counter"
    :density="density"
    :disabled="disabled"
    :hide-details="hideDetails"
    :hint="hint"
    :icon-color="iconColor"
    :label="label"
    :maxlength="maxlength"
    :model-value="modelValue"
    :persistent-hint="persistentHint"
    :placeholder="placeholder"
    :prepend-icon="prependIcon"
    :prepend-inner-icon="prependInnerIcon"
    :readonly="readonly"
    :rules="combinedRules"
    :single-line="singleLine"
    :type="type"
    :v-maska="maskaOptions"
    :variant="variant"
    ref="albatrossTextField"
    v-bind="$attrs"
    @update:model-value="value => emit('update:modelValue', value)"
  >
    <!--    <template v-for="(index, name) in $scopedSlots" v-slot:[name]="data">-->
    <!--      <slot :name="name" v-bind="data"></slot>-->
    <!--    </template>-->

    <!--  do not change :slot to use v-slot here until we are in vue3..this is so dumb  -->
    <!--    <template v-for="(_, slot) in $slots" :slot="slot">-->
    <!--      <slot :name="slot"></slot>-->
    <!--    </template>-->

    <template
      v-for="(_, name) in $slots"
      #[name]="slotData"
    >
      <slot
        :name="name"
        v-bind="slotData"
      />
    </template>
  </v-text-field>
</template>

<script setup>
import { ref, computed } from 'vue'
import constants from '@/helpers/constants'
import { vMaska } from 'maska/vue'
import { objType } from 'html2pdf.js/src/utils.js'

// reminder that v-model is sugar syntax for :value="value" @input="v => $emit('input', v)"
const basicRequiredRule = ref(constants.BASIC_REQUIRED_RULE)

const emit = defineEmits(['update:modelValue'])

const props = defineProps({
  modelValue: [String, Number],
  placeholder: String, //fields without a defined default will default to null
  id: String,
  label: String,
  variant: String,
  hint: String,
  iconColor: String,
  color: String,
  clearIcon: String,
  prependIcon: String,
  prependInnerIcon: String,
  //vue2's appendIconOuter = appendIcon in vue3
  //vue2's appendIcon = appendInnerIcon in vue3
  appendIcon: String,
  appendInnerIcon: String,
  type: {
    type: String,
    default: 'text'
  },
  rules: {
    type: Array,
    default: () => []
  },
  customClasses: {
    type: String,
    default: ''
  },
  autofocus: Boolean,
  autocomplete: String,
  required: Boolean,
  readonly: Boolean,
  disabled: Boolean,
  clearable: Boolean,
  hideDetails: Boolean,
  singleLine: Boolean,
  persistentHint: Boolean,
  density: String,
  step: Number,
  counter: Boolean, //this counter and maxlength is not how vuetify defines the props but it is the only combo that actually stops the user from typing when they hit the limit
  maxlength: Number,
  maskaOptions: {
    type: Object,
    default: () => ({ mask: null })
  }
})

const variants = [
  'underlined',
  'outlined',
  'filled',
  'solo',
  'solo-inverted',
  'solo-filled',
  'plain'
]
const variant = computed(() => {
  if (!variants.includes(props.variant)) {
    return 'underlined'
  }
  return props.variant
})

const albatrossTextField = ref(null)

const combinedRules = computed(() => {
  let tempRules = []
  //set the rules to any rules that were passed in
  tempRules = props.rules
  // if the field is marked as "required" also add the basic required rule
  if (props.required) {
    tempRules = tempRules.concat(basicRequiredRule.value)
  }
  return tempRules
})

const newFocus = () => {
  albatrossTextField.value.focus()
}

defineExpose({
  focus: newFocus
})
</script>

<style lang="scss" scoped></style>
